import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router';
import { NAV_LINKS, BRAND } from '../mock/mockData.js';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <>
      <nav className="navbar">
        <div className="ctr">
          <div className="navi">
            <NavLink to="/" className="nlogo" onClick={() => setOpen(false)}>
              <img src="/assets/totalpe-lockup-transparent-660x160.png" alt="TotalPe" style={{height: '55px', width: 'auto'}}/>
            </NavLink>
            <div className="nlinks">
              {NAV_LINKS.map(l => (
                <NavLink
                  key={l.path}
                  to={l.path}
                  className={({ isActive }) => 'nlink' + (isActive ? ' act' : '')}
                >
                  {l.label}
                </NavLink>
              ))}
              <a href={BRAND.playStoreUrl} className="btn btn-p btn-sm"
                target="_blank" rel="noopener noreferrer">
                Download App
              </a>
            </div>
            <button className="ntoggle" onClick={() => setOpen(true)} aria-label="Open menu">☰</button>
          </div>
        </div>
      </nav>

      <div className={'nmob' + (open ? ' open' : '')}>
        <button className="nmob-close" onClick={() => setOpen(false)}>✕</button>
        <NavLink to="/" className="nlogo" onClick={() => setOpen(false)}>
          <img src="/assets/totalpe-lockup-transparent-660x160.png" alt="TotalPe" style={{height: '55px', width: 'auto'}}/>
        </NavLink>
        {NAV_LINKS.map(l => (
          <NavLink key={l.path} to={l.path} className="nmob-link" onClick={() => setOpen(false)}>
            {l.label}
          </NavLink>
        ))}
        <a href={BRAND.playStoreUrl} className="btn btn-p"
          target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)}>
          📱 Download Free
        </a>
      </div>
    </>
  );
}